var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_11)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#1060EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 25,
    height: 20,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 30,
    x2: 37,
    y2: 30,
    stroke: "#1060EE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7071 19.2929C34.3166 18.9024 33.6834 18.9024 33.2929 19.2929L26.9289 25.6569C26.5384 26.0474 26.5384 26.6805 26.9289 27.0711C27.3195 27.4616 27.9526 27.4616 28.3431 27.0711L34 21.4142L39.6569 27.0711C40.0474 27.4616 40.6805 27.4616 41.0711 27.0711C41.4616 26.6805 41.4616 26.0474 41.0711 25.6569L34.7071 19.2929ZM35 40L35 20H33L33 40H35Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/up-icon.83327d8f02ce75e7892e2751ea96ed33.svg";
export { ForwardRef as ReactComponent };